module.exports = __webpack_public_path__ + "static/media/deleteBannerIcon.67190ccf.svg";